import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { environment } from '@env/environment';
import { MismatchValidator } from '@shared/validators/mismatch-validator';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {

  form: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<any>) {
    this.createForm();
  }

  changePassword() {
    const formValues = this.form.value;
    this.dialogRef.close({
      currentPassword: formValues.currentPassword,
      newPassword: formValues.newPassword
    });
  }

  private createForm() {
    const pattern = environment.passwordPattern;
    this.form = this.formBuilder.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.pattern(pattern)]],
      confirmPassword: ['']
    });

    this.form.get('confirmPassword').setValidators([
      Validators.required,
      MismatchValidator.mismatch(this.form.get('newPassword'))
    ]);
  }
}
